<div class="row mt-3 mb-lg-5 animated fadeIn">
    <div class="col-12 bg-coll">
        <div class="col-10 my-4">
            @for (item of getOrderedSections(); track $index) {
                <div class="my-3" [hidden]="!item.visible">
                    <mnf-pi-v2-info-collapse [infoProject]="infoProject" [item]="item"></mnf-pi-v2-info-collapse>
                </div>
            }
        </div>
    </div>
</div>